import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './NotificationHeader.module.css';
import { useNotificationHeader } from './useNotificationHeader';
import { useTranslation } from 'react-i18next';

interface NotificationHeaderProps {
    classes?: string;
}

export const NotificationHeader = memo(({ classes }: NotificationHeaderProps) => {
    const { t } = useTranslation();
    const { readAll } = useNotificationHeader();

    return (
        <header className={classNames(cls.NotificationHeader, [classes])}>
            <h2 className={cls.head}>{t('NotificationHeader.title')}</h2>
            <span className={cls.linkBtn} onClick={readAll}>
                {t('NotificationHeader.return.linkBtn')}
            </span>
        </header>
    );
});
